import React, { Component,createRef } from 'react';
import {
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
	Collapse,
	TableCell,
	CircularProgress
} from '@material-ui/core';
import swal from 'sweetalert'
import {FormattedMessage} from 'react-intl';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import { StyledTableCell } from '../../commons/utils/TableStyles.js';
import PresupuestoDetail from './PresupuestoDetail.jsx'; // Import the detail component
import PresupuestoAsignacion from './PresupuestoAsignacion.jsx';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import PresupuestoHistorico from './PresupuestoHistorico.jsx';
import Security from '../../commons/security/Security.js';

class PresupuestoGrid extends Component{   
	
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();
		this.inputRefs = [];
		this.presupuestoHistoricoRef = createRef(); // Create a ref for PresupuestoHistorico
		this.state = {
			editMontoGeneral: false,
			editMontoPreventivo: false,
			editMontoCorrectivo: false,
			editMontoGestoria: false,
			editMontoVencimientos: false,
			presupuestos: [],
			loading: false,
			presupuestosBackup: [],
			totalAsignado: "",
			restante: "",
			expandedRows: [], // Track expanded rows
			expandedRowsChild: [], // Track expanded rows
			open: false, // Track if the row is expanded
			isHidden: 'hidden-personal', // Track visibility of the detail row
			disponibles: {}, // Almacenar los valores de presupuesto disponible por ID
			totales: {},
			porcentaje:ConfigBusiness.get('periodoPresupuestario.porcentajeCorte'),
			isCollapsed: false, // Estado para controlar el colapso del componente
			inicioPeriodo:false,
		}

		this.handleEdit = this.handleEdit.bind(this);
	}

	componentDidMount(){
		
	}

	componentWillMount() {
		this.ajaxHandler.subscribe(this);
		this.setState({ loading: true });
		this.initForm();
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	initForm() {
		this.setState({ loading: true });

		Promise.all([
			this.ajaxHandler.getJson('/' + this.props.modulo + '/' + this.props.id + '/presupuestos'),
			this.ajaxHandler.getJson('/presupuestos/' + this.props.presupuestable + '/' + this.props.id + '/total-asignado'),
			this.ajaxHandler.getJson('/presupuestos/' + this.props.presupuestable + '/' + this.props.id + '/restante'),
			this.ajaxHandler.getJson('/presupuestos/' + this.props.presupuestable + '/' + this.props.id + '/presupuesto-resumen-todos'),
			this.ajaxHandler.getJson('/presupuestos/config-periodo-iniciada')
		]).then(([presupuestosData, totalAsignado, restanteData, resumenData, inicioPeriodo]) => {
			let presupuestos = [];
			let disponibles = {};
			let totales = {};
			this.inicioPeriodo = inicioPeriodo;

			// Iterar sobre cada presupuesto y asignar los datos de resumen
			for (const presupuesto of presupuestosData) {
				const total = parseFloat(presupuesto.monto_general) +
					parseFloat(presupuesto.monto_correctivo) +
					parseFloat(presupuesto.monto_preventivo) +
					parseFloat(presupuesto.monto_gestoria) +
					parseFloat(presupuesto.monto_vencimientos);

				const resumen = resumenData.find(r => r.presupuesto_id === presupuesto.id) || {};
				const distribuido = parseFloat(resumen.distribuido) || 0;
				const comprometido = parseFloat(resumen.comprometido) || 0;
				const consumido = parseFloat(resumen.consumido) || 0;


				const disponible = this.props.modulo !== 'bases'
					? total - distribuido
					: total - (comprometido + consumido);

				disponibles[presupuesto.id] = disponible;
				totales[presupuesto.id] = total;

				presupuestos.push({
					...presupuesto,
					monto_general: parseFloat(presupuesto.monto_general),
					monto_preventivo: parseFloat(presupuesto.monto_preventivo),
					monto_correctivo: parseFloat(presupuesto.monto_correctivo),
					monto_gestoria: parseFloat(presupuesto.monto_gestoria),
					monto_vencimientos: parseFloat(presupuesto.monto_vencimientos),
					periodo: presupuesto.periodo,
					editRow: false,
				});
			}

			// Ordenar presupuestos por fecha de inicio
			presupuestos.sort((a, b) => {
				const dateA = new Date(a.periodo.fecha_inicio);
				const dateB = new Date(b.periodo.fecha_inicio);
				return dateA - dateB;
			});

			const restante = totalAsignado - restanteData.total;

			this.setState({
				presupuestos,
				presupuestosBackup: JSON.parse(JSON.stringify(presupuestos)),
				totalAsignado,
				restante,
				disponibles,
				totales,
				loading: false,
			});
		}).catch(error => {
			console.error('Error al inicializar el formulario:', error);
			this.exit();
		});
	}

	exit() {
		this.setState({
			redirectTo: '/bases'
		});
	}

	handleEdit(key, name){
		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
		presupuestosCopy[key][name] = !presupuestosCopy[key][name]
		this.setState({
			presupuestos: presupuestosCopy
		}, () => {
			if (presupuestosCopy[key][name] && this.inputRefs[key+name]) {
				this.inputRefs[key+name].focus();
			}
		});
	}

	handleEditRow(key) {
		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
		let presupuestosBackupCopy = JSON.parse(JSON.stringify(this.state.presupuestosBackup));

		presupuestosCopy.forEach((presupuesto, index) => {
			if (presupuesto.editRow && index !== key) {
				// Si la fila estaba en edición y no es la actual, restaurar los valores originales desde presupuestosBackup
				presupuesto.monto_general = presupuestosBackupCopy[index].monto_general;
				presupuesto.monto_preventivo = presupuestosBackupCopy[index].monto_preventivo;
				presupuesto.monto_correctivo = presupuestosBackupCopy[index].monto_correctivo;
				presupuesto.monto_gestoria = presupuestosBackupCopy[index].monto_gestoria;
				presupuesto.monto_vencimientos = presupuestosBackupCopy[index].monto_vencimientos;
			}
			presupuesto.editRow = index === key ? !presupuesto.editRow : false; // Alternar solo la fila seleccionada
		});

		this.setState({
			presupuestos: presupuestosCopy
		}, () => {
			const inputRef = this.inputRefs[key + "monto_general"];
			if (presupuestosCopy[key].editRow && inputRef) {
				inputRef.focus();
			}
		});
	}

	handleInputFormChange(event, key) {
		const target = event.target;
		const name = target.name;
		const value = target.value;

		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
		presupuestosCopy[key][name] = value;
		this.setState({
			presupuestos: presupuestosCopy
		});
	}

	sendPresupuestoRow(key) {
		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
		const presupuesto = presupuestosCopy[key];
	
		// Llamar a la función para obtener los totales de los hijos asociados
		this.getTotalesHijos(this.props.id, presupuesto.periodo_id, this.props.presupuestable).then((totalesHijos) => {
			// Validar que los montos no sean menores que los totales de los hijos
			if (
				presupuesto.monto_general < totalesHijos.monto_general ||
				presupuesto.monto_preventivo < totalesHijos.monto_preventivo ||
				presupuesto.monto_correctivo < totalesHijos.monto_correctivo ||
				presupuesto.monto_gestoria < totalesHijos.monto_gestoria ||
				presupuesto.monto_vencimientos < totalesHijos.monto_vencimientos
			) {
            swal(
                "Monto no válido",
                "Monto inconsistente respecto a lo ya distribuido",
                "warning"
            );
				return;
			}
	
			// Si la validación pasa, guardar los cambios
			presupuestosCopy[key].editRow = false;
			if (this.diferentePresupuesto(key)) {
				this.props.setLoading(true);
				this.updatePresupuesto(presupuestosCopy[key].id, presupuestosCopy[key]);
			}
		});
	}

	getTotalesHijos(presupuestoId, periodoId, presupuestableType) {
		return this.ajaxHandler
			.getJson(`/presupuestos/subregiones-bases/${presupuestoId}?periodoId=${periodoId}&presupuestableType=${presupuestableType}`)
			.then((response) => {
				return response.reduce((totales, item) => {
					totales.monto_general += parseFloat(item.monto_general) || 0;
					totales.monto_preventivo += parseFloat(item.monto_preventivo) || 0;
					totales.monto_correctivo += parseFloat(item.monto_correctivo) || 0;
					totales.monto_gestoria += parseFloat(item.monto_gestoria) || 0;
					totales.monto_vencimientos += parseFloat(item.monto_vencimientos) || 0;
					return totales;
				}, {
					monto_general: 0,
					monto_preventivo: 0,
					monto_correctivo: 0,
					monto_gestoria: 0,
					monto_vencimientos: 0,
				});
			})
			.catch((error) => {
				console.error("Error al obtener los totales de los hijos:", error);
			});
	}

	cancelEditRow(key) {
		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestosBackup));
		presupuestosCopy[key].editRow = false;
		this.setState({
			presupuestos: presupuestosCopy
		});
	}

	diferentePresupuesto(key){
		if(this.state.presupuestos[key].monto_general !== this.state.presupuestosBackup[key].monto_general){
			return true
		}
		if(this.state.presupuestos[key].monto_preventivo !== this.state.presupuestosBackup[key].monto_preventivo){
			return true
		}
		if(this.state.presupuestos[key].monto_correctivo !== this.state.presupuestosBackup[key].monto_correctivo){
			return true
		}
		if(this.state.presupuestos[key].monto_gestoria !== this.state.presupuestosBackup[key].monto_gestoria){
			return true
		}
		if(this.state.presupuestos[key].monto_vencimientos !== this.state.presupuestosBackup[key].monto_vencimientos){
			return true
		}
		return false;
	}


	toggleCollapseSection = () => {
        this.setState((prevState) => ({
            isCollapsed: !prevState.isCollapsed,
        }));
    };

	toggleCollapse(key) {
		this.setState((prevState) => {
			const isRowCurrentlyExpanded = prevState.expandedRows.includes(key);
			return {
				expandedRows: isRowCurrentlyExpanded ? [] : [key], // Ensure only one parent dropdown is open
				expandedRowsChild: [], // Close any child dropdowns when toggling parent
				isHidden: isRowCurrentlyExpanded ? 'hidden-personal' : 'block',
			};
		});
	}

	toggleCollapseChild(key) {
		this.setState((prevState) => {
			const isChildRowCurrentlyExpanded = prevState.expandedRowsChild.includes(key);
			return {
				expandedRowsChild: isChildRowCurrentlyExpanded ? [] : [key], // Ensure only one child dropdown is open
				expandedRows: [], // Close any parent dropdowns when toggling child
			};
		});
	}

	updatePresupuesto(id, rowData) {
		const body = {
			monto_general: parseFloat(rowData.monto_general),
			monto_preventivo: parseFloat(rowData.monto_preventivo),
			monto_correctivo: parseFloat(rowData.monto_correctivo),
			monto_gestoria: parseFloat(rowData.monto_gestoria),
			monto_vencimientos: parseFloat(rowData.monto_vencimientos),
		};

		return this.ajaxHandler.fetch(`/presupuestos/${id}`, {
			method: 'PATCH',
			body: JSON.stringify(body),
		}).then(response => {
			if (response.status === 400) {
				return response.json().then(data => {
					swal(data.detalle[0], "", "error");
				});
			}
		}).catch(error => {
			this.ajaxHandler.handleError(error);
		}).finally(() => {
			this.initForm();
			this.props.setLoading(false);
		});
	}

	getIconColor(disponible, totales) {

		if (totales === 0 && disponible === 0) return 'gray'; // Handle division by zero case

		const porcentaje = (disponible / totales) * 100;

		if (porcentaje === 100) return '#474789';
		if (porcentaje >= this.state.porcentaje) return '#28D094';
		if (porcentaje > 0) return '#F1EA7F';
		return '#FF4961';
	}

	handleVerHistorico = () => {
        if (this.presupuestoHistoricoRef.current) {
            this.presupuestoHistoricoRef.current.fetchPresupuestoHistorico(); // Call the fetch function
        }
    };

	render() {
		const { isCollapsed } = this.state;
		return (
			<div className="card" style={{borderLeftColor: '#00c0bd'}}>
                <div className="card-header" onClick={this.toggleCollapseSection} style={{ cursor: 'pointer' , backgroundColor: '#00c0bd',padding:'12px',borderRadius:'0px 0.35rem 0.35rem 0px' }}>
                    <h4 className="form-section" style={{ borderBottom: 'none', color: 'white',marginBottom: '0px' }}>
                        <i className="las la-clipboard-list"></i>
                        <FormattedMessage id="presupuestoGrid.information.Presupuesto" defaultMessage="Presupuesto" />
						<i className={`fa ${isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'}`} style={{ float: 'right', paddingTop: '10px' }}></i>
                    </h4>
                </div>
                <Collapse in={!isCollapsed} timeout="auto" unmountOnExit>
                    <div className="card-content">
                        <div className="card-body">
						{this.state.loading ? ( // Mostrar CircularProgress mientras loading sea true
							<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
								<CircularProgress />
							</div>
							) : (
							<>
							<div className="row">
								<div className="col-md-4">
									<div className="form-group row">
										<label className="col-md-7 label-control col-form-label" htmlFor="descripcion">
											<FormattedMessage id="presupuestoGrid.presupuesto.presupuesto_total_asignado" defaultMessage="Presupuesto Total Asignado"/>:
										</label>
										<div className="col-md-5">
											<div
												className="form-control-static col-form-label"
												style={{ color: this.state.totalAsignado > 0 ? '#474789' : 'inherit', fontWeight: '600' }}
											>
												{this.state.totalAsignado}
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group row">
										<label className="col-md-7 label-control col-form-label" htmlFor="Presupuesto Restante">
											<FormattedMessage id="presupuestoGrid.presupuesto.presupuesto_restante" defaultMessage="Presupuesto Restante:"/>
										</label>
										<div className="col-md-5">
											<div
												className="form-control-static col-form-label"
												style={{ color: this.getIconColor(this.state.restante, this.state.totalAsignado), fontWeight: '600' }}
											>
												{this.state.restante}
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
									<div
										className="color-legend"
										style={{
											display: 'flex',
											flexDirection: 'row', // Disposición horizontal
											alignItems: 'center',
											justifyContent: 'flex-end',
											flexWrap: 'wrap', // Ajustar si el espacio es limitado
											gap: '2px', // Espaciado entre los colores
											marginBottom: '1.5rem',
										}}
									>
										{['#474789', '#28D094', '#F1EA7F', '#FF4961', 'gray'].map((color) => (
											<div
												key={color}
												style={{
													display: 'flex',
													alignItems: 'center',
													position: 'relative', // Necesario para posicionar el tooltip
												}}
												onMouseEnter={() => this.setState({ activeColor: color })} // Mostrar información al pasar el cursor
												onMouseLeave={() => this.setState({ activeColor: null })} // Ocultar información al salir del cursor
											>
												<div
													style={{
														width: '20px',
														height: '20px',
														backgroundColor: color,
														marginRight: '5px',
														borderRadius: '50%',
													}}
												></div>
												{this.state.activeColor === color && (
													<span
														style={{
															position: 'absolute',
															top: '20px', // Posicionar debajo del color
															right: '0',
															backgroundColor: '#fff',
															padding: '5px',
															borderRadius: '5px',
															boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
															whiteSpace: 'nowrap', // Evitar que el texto se corte
															zIndex: 10, // Asegurar que el tooltip esté encima
														}}
													>
														<FormattedMessage
															id={`presupuestoGrid.legend.${color}`}
															defaultMessage={
																color === '#474789'
																	? '100% del Presupuesto disponible'
																	: color === '#28D094'
																	? `Más del ${this.state.porcentaje}% del Presupuesto disponible`
																	: color === '#F1EA7F'
																	? `Menos del ${this.state.porcentaje}% del Presupuesto disponible`
																	: color === '#FF4961'
																	? 'Sin Presupuesto Disponible o Presupuesto excedido'
																	: 'Sin Presupuesto Asignado'
															}
														/>
													</span>
												)}
											</div>
										))}
								</div>
							</div>
							</div>
							<div className="row">
								<TableContainer>
									<Table aria-label="clases table">
										<TableHead>
											<TableRow>											
												<StyledTableCell align="left" style={{ width: '30px' }}>
												</StyledTableCell>
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto_table.column_nombre_periodo.label" defaultMessage="NOMBRE DEL PERIODO" />
												</StyledTableCell>
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto_table.column_fecha_inicio.label" defaultMessage="FECHA INICIO" />
												</StyledTableCell>
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto_table.column_fecha_fin.label" defaultMessage="FECHA FIN" />
												</StyledTableCell>
												{this.props.modulo !== 'bases' && (
													this.props.modulo === 'regiones' ? (
														<StyledTableCell align="left" style={{ width: '60px' }}>
															<FormattedMessage id="presupuestoGrid.presupuesto_table.column_subregiones" defaultMessage="SUBREGIONES" />
														</StyledTableCell> ) :
													this.props.modulo === 'subregiones' && (
														<StyledTableCell align="left" style={{ width: '60px' }}>
															<FormattedMessage id="presupuestoGrid.presupuesto_table.column_bases" defaultMessage="BASES" />
														</StyledTableCell> )
												)}
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto_table.column_general.label" defaultMessage="GENERAL" />
												</StyledTableCell>
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto_table.column_preventivo.label" defaultMessage="PREVENTIVO" />
												</StyledTableCell>
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto_table.column_correctivo.label" defaultMessage="CORRECTIVO" />
												</StyledTableCell>
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto.column_gestoria.label" defaultMessage="GESTORIA" />
												</StyledTableCell>
												<StyledTableCell align="left">
													<FormattedMessage id="presupuestoGrid.presupuesto.column_vencimientos.label" defaultMessage="VENCIMIENTO" />
												</StyledTableCell>
												{this.props.modulo == 'regiones' && (!this.inicioPeriodo || Security.hasPermission('PRESUPUESTO_EDITAR_MONTOS_PERIODO')) ? (
													<StyledTableCell align="center">
													</StyledTableCell>
												) : null}
											</TableRow>
										</TableHead>
										<TableBody>
										{this.state.loading && (
										<TableRow>
											<StyledTableCell colSpan={11} align="center">
												<CircularProgress />
											</StyledTableCell>
										</TableRow>
										)}
										{!this.state.loading &&
										(this.state.presupuestos && this.state.presupuestos.map((presupuesto,key) => {
										const hasMontoGeneral = presupuesto.monto_general > 0;
										const hasOtherMontos = ['monto_preventivo', 'monto_correctivo', 'monto_gestoria', 'monto_vencimientos']
											.some(field => presupuesto[field] > 0);
										const disponible = this.state.disponibles[presupuesto.id] || 0;
										const totales = this.state.totales[presupuesto.id] || 0;
										const color = this.getIconColor(disponible, totales);

										return (
											<React.Fragment key={key}>
												<TableRow>
													<StyledTableCell>
														<div className="d-flex align-items-center">
															<div onClick={() => this.toggleCollapse(key)}>
																{this.state.expandedRows.includes(key) ? (
																	<i className="fa fa-2x fa-angle-double-down personal-no-focus avatar-plus-detail pointer"></i>
																) : (
																	<i className="fa fa-angle-double-right fa-2x personal-no-focus avatar-plus-detail pointer"></i>
																)}
															</div>
															<i
																className="fa fa-circle"
																style={{ color: color, fontSize: '1.5rem', marginLeft: '10px' }}
																title={totales === 0 ? 'Sin presupuesto asignado' : `Disponible: ${disponible}`}
															></i>
														</div>
													</StyledTableCell>
													<StyledTableCell>
														<div className="text-center" style={{ minWidth: '50px' }}>
															{presupuesto.periodo ? presupuesto.periodo.nombre : ''}
														</div>
													</StyledTableCell>
													<StyledTableCell align="left">{presupuesto.periodo ? presupuesto.periodo.fecha_inicio : ''}</StyledTableCell>
													<StyledTableCell align="left">{presupuesto.periodo ? presupuesto.periodo.fecha_fin : ''}</StyledTableCell>
													{this.props.modulo !== 'bases' && (
													<StyledTableCell>	
														<div className="d-flex align-items-center" style={{ justifyContent: 'center' }}>
															<div onClick={() => this.toggleCollapseChild(key)}>
																{this.state.expandedRowsChild.includes(key) ? (
																	<i className="fa fa-2x fa-angle-double-down personal-no-focus avatar-plus-detail pointer"></i>
																) : (
																	<i className="fa fa-angle-double-right fa-2x personal-no-focus avatar-plus-detail pointer"></i>
																)}
															</div>
														</div>
													</StyledTableCell>
													)}
													<StyledTableCell align="left" style={{ backgroundColor: !presupuesto.editRow && hasOtherMontos ? '#d3d3d3' : 'inherit' }}>
														{presupuesto.editRow ? (
															<input
																ref={(el) => (this.inputRefs[key + 'monto_general'] = el)}
																type="number"
																name="monto_general"
																value={presupuesto.monto_general === 0 ? "" : presupuesto.monto_general} // Mostrar vacío si el valor es 0
																onChange={(event) => this.handleInputFormChange(event, key)}
																placeholder='0'
																style={{ width: '110px' }}
																disabled={hasOtherMontos} // Deshabilitar si aplica exclusividad
															/>
														) : (
															presupuesto.monto_general
														)}
													</StyledTableCell>
													{['monto_preventivo', 'monto_correctivo', 'monto_gestoria', 'monto_vencimientos'].map((field) => (
														<StyledTableCell
															key={field}
															align="left"
															style={{ backgroundColor: !presupuesto.editRow && hasMontoGeneral ? '#d3d3d3' : 'inherit' }}
														>
															{presupuesto.editRow ? (
																<input
																	ref={(el) => (this.inputRefs[key + field] = el)}
																	type="number"
																	name={field}
																	value={presupuesto[field] === 0 ? "" : presupuesto[field]} // Mostrar vacío si el valor es 0
																	onChange={(event) => this.handleInputFormChange(event, key)}
																	placeholder='0'
																	style={{ width: '110px' }}
																	disabled={hasMontoGeneral} // Deshabilitar si aplica exclusividad
																/>
															) : (
																presupuesto[field]
															)}
														</StyledTableCell>
													))}
													{this.props.modulo == 'regiones' && (!this.inicioPeriodo || Security.hasPermission('PRESUPUESTO_EDITAR_MONTOS_PERIODO')) ? (
														<StyledTableCell align="center">
															{presupuesto.editRow ? (
																<>
																	<button
																		type="button"
																		className="btn btn-sm btn-icon btn-dt-grid text-success"
																		onClick={() => this.sendPresupuestoRow(key)}
																		style={{ width: '30px' }}
																	>
																		<i className="fa fa-check fa-xs" />
																	</button>
																	<button
																		type="button"
																		className="btn btn-sm btn-icon btn-dt-grid text-danger"
																		onClick={() => this.cancelEditRow(key)}
																		style={{ width: '30px' }}
																	>
																		<i className="fa fa-times fa-xs" />
																	</button>
																</>
															) : (
																<button
																	type="button"
																	className="btn btn-sm btn-icon btn-dt-grid text-success"
																	onClick={() => this.handleEditRow(key)}
																	style={{ width: '30px' }}
																>
																	<i className="fa fa-pencil fa-xs" />
																</button>
															)}
														</StyledTableCell>
													) : null}
												</TableRow>
												<TableRow className={this.state.isHidden}>
													<TableCell
														style={{ paddingBottom: 0, paddingTop: 0, background: 'rgb(244, 245, 250)' }}
														colSpan={11}
													>
														<Collapse in={this.state.expandedRows.includes(key)} timeout={{ enter: 700, exit: 500 }} unmountOnExit>
															<PresupuestoDetail presupuesto={presupuesto} relacion={this.props} />
														</Collapse>
													</TableCell>
												</TableRow>
												{this.props.modulo !== 'bases' && (
												<TableRow className={this.state.isHiddenChild}>
													<TableCell
														style={{ paddingBottom: 0, paddingTop: 0, background: 'rgb(244, 245, 250)' }}
														colSpan={11}
													>
														<Collapse in={this.state.expandedRowsChild.includes(key)} timeout={{ enter: 700, exit: 500 }} unmountOnExit>
															<PresupuestoAsignacion presupuesto={presupuesto} relacion={this.props}  />
														</Collapse>
													</TableCell>
												</TableRow>
												)}
											</React.Fragment>
										);
									}))
									}
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						{this.props.modulo == 'regiones' && (
						<div className="row">
							<div className="col-md-12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<button
									type="button"
									className="btn btn-primary"
									data-toggle="modal" 
									data-target="#verHistorico_modal"
									onClick={this.handleVerHistorico}
									style={{ marginTop: '10px' }}
								>
									<FormattedMessage id="presupuestoGrid.button.ver_historico" defaultMessage="Ver Histórico" />
								</button>
							</div>
						</div>)}
						</>)}
					</div>
				</div>
				</Collapse>
				<div className="modal fade" tabIndex="-1" id="verHistorico_modal" role="dialog" aria-labelledby="myModalLabel">
					<div className="modal-xl modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header bg-fleet">
								<h4 className="modal-title text-white" id="myModalLabel"><FormattedMessage id="presupuestoGrid_modal.finish_button.ok" defaultMessage="Histórico de Presupuestos"/></h4>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
							</div>
							<div className="modal-body modal-mh ovf-x-hidden">
							<PresupuestoHistorico ref={this.presupuestoHistoricoRef} />
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-default btn-fleet" data-dismiss="modal"><FormattedMessage id="presupuestoGrid_modal.finish_button.ok" defaultMessage="Ok"/></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

} export default PresupuestoGrid;
